const aaa = [

	{
		path: "Newmoneypk",
		component: () => import("@/views/shuju/Newmoneypk.vue"),
		meta:{title:'新业绩pk'},
	},
	{
		path: "staffshuju",
		component: () => import("@/views/shuju/staffroyalty.vue"),
		meta:{title:'员工提成'},
	},
	{
		path: "List",
		component: () => import("@/views/shuju/newpk/staffroyaltyList.vue"),
		meta:{title:'提成设置列表'},
	},
	
	
]
export default aaa;